import L from "leaflet";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

//
// show is only passed in order to use it as a dependency in the useEffect hook. When the show prop changes, the previous control is removed and a new one is added.
// Without it, the order of the controls can be incorrect due to how Leaflet handles control addition and removal.
//
type Props = {
    onClick: (e: Event) => void;
    show: boolean;
};

function MapDeleteButton({ onClick, show }: Props) {
    const map = useMap();

    useEffect(() => {
        const customControl = L.Control.extend({
            options: {
                position: "topright"
            },
            onAdd: function () {
                const container = L.DomUtil.create("div", "leaflet-bar leaflet-control");
                container.style.marginTop = "5px"

                const button = L.DomUtil.create("a", "", container);
                button.href = "#";
                button.title = "Delete Polygon";
                button.style.color = "#464646";
                button.setAttribute("role", "button");
                button.setAttribute("aria-label", "Delete Polygon");

                L.DomUtil.create("i", "fas fa-trash", button);

                L.DomEvent.on(button, "click", (e) => {
                    L.DomEvent.stopPropagation(e);
                    L.DomEvent.preventDefault(e);
                    onClick(e);
                }); 

                return container;
            }
        });

        const control = new customControl();
        map.addControl(control);

        return () => {
            map.removeControl(control);
        };
    }, [map, onClick, show]);

    return null;    
}

export default MapDeleteButton;
